var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 360,
    viewBox: "0 0 676 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 676,
    height: 360
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676 8C676 3.58172 672.418 0 668 0H8C3.58172 0 0 3.58172 0 8V352C0 356.418 3.58173 360 8 360H432.608C434.776 360 436.851 359.12 438.358 357.562L495.543 298.438C497.05 296.88 499.125 296 501.293 296H668C672.418 296 676 292.418 676 288V8Z",
    fill: "#091415"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 676,
    height: 360,
    fill: "#121517"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 676,
    height: 200,
    fill: "url(#paint0_linear_41_7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_7",
    x1: 339.04,
    y1: 160,
    x2: 339.04,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19636B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerCard);
export default __webpack_public_path__ + "static/media/career-card.aca668808c3922bf33a141b062aafbd8.svg";
export { ForwardRef as ReactComponent };